import { render, staticRenderFns } from "./deleteuser.vue?vue&type=template&id=53fda20f&"
import script from "./deleteuser.vue?vue&type=script&lang=js&"
export * from "./deleteuser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports